import { GenIcon } from '../helpers/IconBase.es.js';

const BulletedListOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "3", cy: "7", r: "2", fill: "#7D7D7D" } },
      { tag: "circle", attr: { cx: "3", cy: "17", r: "2", fill: "#7D7D7D" } },
      {
        tag: "rect",
        attr: {
          x: "7",
          y: "6",
          width: "16",
          height: "2",
          rx: "1",
          fill: "#7D7D7D"
        }
      },
      {
        tag: "rect",
        attr: {
          x: "7",
          y: "16",
          width: "16",
          height: "2",
          rx: "1",
          fill: "#7D7D7D"
        }
      }
    ]
  })(props);
};

export { BulletedListOutlined };
